import debug from 'debug';
import { commonApi, companyUUID, getShopifyUserId } from '@/service/api';
import { STORAGE_KEY } from '@/constant/constant';
import { formEventV2 } from '@/service/formEventV2';
import { setLocal } from '@/utils/storage';
import { renderSoldOutButton } from './shopify';
const log = debug('cartsee:push');

export const initCartsee = (load: (actionType: number, url: string, externalRes?: any, coupon?: string, options?: any) => void) => {
  var queue = window.cartsee || [];
  var config = { version: '1.0.0' };

  function cartsee() {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var params = args.slice(1);
    log('cartsee method=%s params=%o', method, params);

    switch (method) {
      case 'openForm':
        log('Opening Form: formId=%s', params[0]);
        load(8, 'form/out/leaveLoad', {}, undefined, { trigger: 'click', formId: params[0] });
        break;
      case 'signup':
        if (params[0] && typeof params[0] === 'object') {
          const signupParams = {
            ...params[0],
            companyUUID,
            shopifyUserId: getShopifyUserId()
          };
          log('Signup cache submit: params=%o', signupParams);
          commonApi(signupParams, 'form/out/signup/cache')
            .then((response) => {
              const email = signupParams.email || '';
              const phone = signupParams.phone || '';

              setLocal(STORAGE_KEY.CARTX_CUSTOMER, JSON.stringify({ email, phone }));
              window?.postMessage('_cartsee_send');

              if (response?.data?.data?.cid) {
                setLocal(STORAGE_KEY.CID, response.data.data.cid);
              } else if (response?.data?.data?.formUid) {
                setLocal(STORAGE_KEY.FORM_UID, response.data.data.formUid);
              }

              formEventV2({
                event: 'cartsee_signup',
                inputType: email ? 'email' : 'phone',
                email,
                phone
              }).catch((error) => {
                log('Signup event submit failed: error=%o', error);
              });
            })
            .catch((error) => {
              log('Signup cache submit failed: error=%o', error);
            });
        } else {
          log('Signup cache skipped: invalid params=%o', params[0]);
        }
        break;
      case 'variant:changed':
        log('Variant changed: variant=%o wrapper=%o', params[0], params[1]);
        renderSoldOutButton(params[0], params[1]);
        break;
      case 'config':
        if (params[0] && typeof params[0] === 'object') {
          Object.assign(config, params[0]);
        }
        break;
      default:
        log('Unknown Method: method=%s params=%o', method, params);
    }
  }

  // 处理队列
  for (var i = 0; i < queue.length; i++) {
    var call = queue[i];
    if (Array.isArray(call)) cartsee.apply(null, call);
  }

  cartsee.version = config.version;
  // 直接给cartsee添加push方法
  cartsee.push = function (call) {
    if (Array.isArray(call)) cartsee.apply(null, call);
  };

  window.cartsee = cartsee;
};
